import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { TRANSACTION } from "@/shared/resource/apis/endpoints";
import { dateTime } from "@/shared/utills/date";
import { TRANSACTION_INFORMATION } from "@/shared/resource/constants";

export const useTransactionStore = defineStore("transaction", {
  state: () => ({
    transactions: [],
    totalTransactions: 0,
    transactionInformation: [...TRANSACTION_INFORMATION],
  }),

  actions: {
    clearTransactions() {
      this.transactions = [];
      this.totalTransactions = 0;
    },

    async fetchTransactions({ page = 1, limit = 10, filters = {} }) {
      this.clearTransactions();

      const response = await api.get(TRANSACTION.GET, {
        params: { page_no: page, limit, ...filters },
      });
      const data = response?.data?.data || [];

      const formattedTransactions = data.map((transaction) => ({
        id: transaction.id,
        transactionId: transaction.transaction_id,
        customerId: transaction.customer_id,
        customerName: transaction.customer_name,
        phoneNumber: transaction.customer_contact || "-",
        createdAt: dateTime.formatDateTime(transaction.created_at),
        payUReference: transaction.pay_u_reference || "-",
        payUTransactionId: transaction.pay_u_transaction_id || "-",
        amount: transaction.amount,
        amountStatus: transaction.amount_debited,
        bookingStatus: transaction.booking_status,
        refundStatus: transaction.refunded,
      }));

      this.setTransactions(
        formattedTransactions,
        response?.data?.total_entries || 0
      );
      return formattedTransactions;
    },

    setTransactions(transactions, total) {
      this.transactions = transactions;
      this.totalTransactions = total;
    },

    async updateTransaction(transactionId, payload) {
      const response = await api.put(
        TRANSACTION.UPDATE(transactionId),
        payload
      );
      return response.data;
    },
  },

  getters: {
    getTransactions: (state) => state.transactions,
    getTotalTransactions: (state) => state.totalTransactions,
    getTransactionInformation: (state) => state.transactionInformation,
  },
});
